<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Primera Intervención Francesa</h2>
    <img @click="imageClicked(0)" src="galerias/sala1/S1_G4.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Captura del Fuerte San Juan de Ulúa, 27 de noviembre 1838</b><br>
        Autor: Horace Vernet<br>
        Año: 1841<br>
        Técnica: Óleo sobre tela<br>
        Medidas: 512 cm x 712 cm<br>
        Colección: Palacio de Versalles<br>
    </p>
    <br>
    <p>La persistente crisis política y financiera hizo a México un país vulnerable a los ataques extranjeros, tal es el caso del conflicto diplomático y militar que se dio de abril de 1838 a marzo de 1839, entre Francia y México, en la llamada “Guerra de los Pasteles”.</p>
    <p>Con el argumento de la defensa de sus connacionales, Francia exigió la indemnización de $60,000 pesos, debido a que comerciantes franceses, como el pastelero Remontel, habían tenido que cerrar sus negocios a causa de las deudas acumuladas por el no pago ante sus servicios prestados y los daños sufridos por los conflictos entre federalistas y centralistas. Dichas acciones llegaron a una vía de reclamo diplomático que favorecía un intervencionismo armado francés en el territorio mexicano con la argumentación de defender los intereses nacionales de Francia.  El ataque al territorio pasaba inicialmente por bloquear el puerto atlántico más importante, Veracruz. Al frente de este conflicto estuvo el Gral. Santa Anna quien, luego de ser herido y sufrir la amputación de su pierna, tuvo que ceder a las exigencias y reconocer el pago de una deuda “por daños” que alcanzó los $600,000 pesos de la época, entre otros acuerdos. El 9 de marzo de 1839 ambos países firmaron un tratado de paz.</p>
    <p></p>
    <h5>Ver más:</h5>
    <p>Si quieres saber más sobre la Guerra de los Pasteles, visita:<br>
        <a target="_blank" href="https://inehrm.gob.mx/es/inehrm/La_Guerra_de_los_pasteles">inehrm.gob.mx</a><br>
        <a target="_blank" href="https://www.youtube.com/watch?v=i8mRbSRn5Fk">www.youtube.com</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "s12g04",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
